<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="1">
        <router-link :to="{ name: 'OldMutualProtect' }" class="back-arrow">
          <v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon>
        </router-link>
      </v-col>
      <v-col cols="12" sm="11">
        <h1>Thank you.</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="8" offset-sm="2">
            <p class="mb-6">
              Your adviser, <strong>{{ adviserName }}</strong
              >, will be in touch to walk you through suitable cover options for
              your estate.
            </p>

            <p class="mb-2"><strong>What happens next:</strong></p>

            <ul>
              <li>
                They'll use these details to tailor the right level of cover for
                your needs
              </li>
              <li>
                They'll contact you directly to talk through your options and
                answer any questions
              </li>
              <li>
                A copy of this information is saved to your profile for your
                records
              </li>
            </ul>

            <p class="mt-8">
              You can return to your dashboard now to download your completed
              will from the left-hand navigation.
            </p>
          </v-col>
        </v-row>

        <v-row class="text-center">
          <v-col cols="12">
            <GradientButton
              title="RETURN TO DASHBOARD"
              :small="true"
              @gradientButtonClicked="$router.push('/overview')"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mdiArrowLeft } from '@mdi/js';
  import GradientButton from '../guest/GradientButton.vue';

  export default {
    name: 'OldMutualProtectConfirm',
    components: {
      GradientButton,
    },
    props: {
      testator: {
        required: false,
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        icons: { mdiArrowLeft },
      };
    },
    computed: {
      adviserName() {
        return this.testator?.advisor?.fullName || 'your adviser';
      },
    },
  };
</script>
